import { RouteObject } from 'react-router-dom';
import HomePage from '@/pages/home/page';
import AboutPage from '@/pages/about/page';
import ServicesPage from '@/pages/services/page';
import ProductsPage from '@/pages/products/page';
import ContactPage from '@/pages/contact/page';
import BusinessConsultingPage from '@/pages/business-consulting/page';
import NotFound from '@/pages/NotFound';

import Login from '@/pages/crm/Login';
import VerifyEmail from '@/pages/crm/VerifyEmail';
import AdminDashboard from '@/pages/crm/AdminDashboard';
import EmployeeDashboard from '@/pages/crm/EmployeeDashboard';
import ClientDashboard from '@/pages/crm/ClientDashboard';
import PrivateRoute from '@/components/crm/PrivateRoute';
import DashboardRedirect from '@/pages/crm/DashboardRedirect';

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/about', element: <AboutPage /> },
  { path: '/services', element: <ServicesPage /> },
  { path: '/products', element: <ProductsPage /> },
  { path: '/business-consulting', element: <BusinessConsultingPage /> },
  { path: '/contact', element: <ContactPage /> },
  
  // Rutas del CRM
  { path: '/crm/login', element: <Login /> },
  { path: '/crm/verify-email', element: <VerifyEmail /> },
  { path: '/crm/dashboard', element: <DashboardRedirect /> },
  { 
    path: '/crm/admin', 
    element: <PrivateRoute allowedRoles={['admin']}><AdminDashboard /></PrivateRoute> 
  },
  { 
    path: '/crm/employee', 
    element: <PrivateRoute allowedRoles={['employee']}><EmployeeDashboard /></PrivateRoute> 
  },
  { 
    path: '/crm/client', 
    element: <PrivateRoute allowedRoles={['client']}><ClientDashboard /></PrivateRoute> 
  },
  
  { path: '*', element: <NotFound /> },
];

export default routes;
